import ApexCharts from 'apexcharts';

// Sales Order Chart
const getSalesOrderChartOptions = (deliveredPercent, billedPercent) => {
	return {
		series: [deliveredPercent, billedPercent],
		colors: ["#1C64F2", "#16BDCA"],
		chart: {
			height: "380px",
			width: "100%",
			type: "radialBar",
			sparkline: {
				enabled: true,
			},
		},
		plotOptions: {
			radialBar: {
				track: {
					background: '#E5E7EB',
				},
				dataLabels: {
					show: false,
				},
				hollow: {
					margin: 0,
					size: "22%",
				}
			},
		},
		labels: [], 
		legend: {
			show: false,
		},
	}
}

if (document.getElementById("radial-chart")) {
	const deliveredPercent = parseFloat(document.getElementById("radial-chart").dataset.delivered);
	const billedPercent = parseFloat(document.getElementById("radial-chart").dataset.billed);
	const chart = new ApexCharts(document.getElementById("radial-chart"), getSalesOrderChartOptions(deliveredPercent, billedPercent));
	chart.render();

	// init again when toggling dark mode
	document.addEventListener('dark-mode', function () {
		chart.updateOptions(getSalesOrderChartOptions(deliveredPercent, billedPercent));
	});
}

// Claim Results Chart
const getClaimResultsChartOptions = (claimResultsData) => {
	return {
		series: [{
			name: 'Claim Count',
			data: claimResultsData.map(item => item.count)
		}],
		chart: {
			type: 'bar',
			height: 350,
			background: 'transparent',
			events: {
				mounted: function (chartContext, config) {
					document.addEventListener('dark-mode', function () {
						chartContext.updateOptions({
							theme: {
								mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light'
							},
							xaxis: {
								labels: {
									style: {
										colors: document.documentElement.classList.contains('dark') ? '#9CA3AF' : '#4B5563'
									}
								}
							},
							yaxis: {
								labels: {
									style: {
										colors: document.documentElement.classList.contains('dark') ? '#9CA3AF' : '#4B5563'
									}
								}
							}
						});
					});
				}
			}
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: '55%',
				endingShape: 'rounded'
			},
		},
		dataLabels: {
			enabled: false
		},
		stroke: {
			show: true,
			width: 2,
			colors: ['transparent']
		},
		xaxis: {
			categories: claimResultsData.map(item => item.custom_result),
			labels: {
				style: {
					colors: document.documentElement.classList.contains('dark') ? '#9CA3AF' : '#4B5563'
				}
			}
		},
		yaxis: {
			title: {
				text: 'Count',
				style: {
					color: document.documentElement.classList.contains('dark') ? '#9CA3AF' : '#4B5563'
				}
			},
			labels: {
				style: {
					colors: document.documentElement.classList.contains('dark') ? '#9CA3AF' : '#4B5563'
				}
			}
		},
		fill: {
			opacity: 1
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val;
				}
			}
		},
		theme: {
			mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light'
		}
	};
};

if (document.getElementById("claim-results-chart")) {
	const claimResultsData = JSON.parse(document.getElementById("claim-results-data").textContent);
	const chart = new ApexCharts(document.getElementById("claim-results-chart"), getClaimResultsChartOptions(claimResultsData));
	chart.render();
}
